import React from "react";
import {
  FaCubes,
  FaShieldAlt,
  FaBolt,
  FaPiggyBank,
  FaPlug,
  FaLock,
  FaMobileAlt,
  FaSyncAlt,
} from "react-icons/fa";

function WeOfferMargin() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-35 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Features of Our Margin Trading Exchange
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaCubes size={40} />
                      </div>
                      <h4>Modular Architecture</h4>
                      <p>
                        Our development approach utilizes a modular framework,
                        ensuring scalability and flexibility, so that new
                        features, tools, or asset classes can be easily
                        integrated into the exchange as needed.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaShieldAlt size={40} />
                      </div>
                      <h4>Integrated Risk Management</h4>
                      <p>
                        Implemented with advanced risk management features such
                        as automated margin calls, stop-loss mechanisms, and
                        liquidation engines to protect both the platform and its
                        users.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaBolt size={40} />
                      </div>
                      <h4>High-Performance Matching Engine</h4>
                      <p>
                        We provide an optimized order matching engine capable of
                        handling high-frequency trades with minimal latency,
                        ensuring a smooth and responsive trading experience for
                        users.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaPiggyBank size={40} />
                      </div>
                      <h4>Secure Lending and Borrowing Pools</h4>
                      <p>
                        Secure lending pools that provide liquidity for margin
                        trading, with built-in smart contracts to manage
                        interest rates and loan collateralization.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaPlug size={40} />
                      </div>
                      <h4>API Integration</h4>
                      <p>
                        Our platform offers comprehensive APIs, allowing
                        seamless integration with external services, including
                        market data providers, liquidity providers, and external
                        trading bots.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaLock size={40} />
                      </div>
                      <h4>Multi-Layer Security</h4>
                      <p>
                        We implement multi-layer security protocols, including
                        encrypted communications, two-factor authentication
                        (2FA), and cold storage integration to safeguard user
                        assets and data.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaMobileAlt size={40} />
                      </div>
                      <h4>Cross-Platform Compatibility</h4>
                      <p>
                        The platform is designed to work seamlessly across
                        desktop, web, and mobile applications, ensuring a
                        consistent user experience across all devices.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon ">
                        <FaSyncAlt size={40} />
                      </div>
                      <h4>Real-Time Data Synchronization</h4>
                      <p>
                        Developers can offer users real-time data
                        synchronization across their accounts, allowing instant
                        updates on positions, balances, and market movements
                        without lag.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WeOfferMargin;
